module.exports = __webpack_public_path__ + "img/1-1.a4b6fd21.png";